/**
 * created by yxy
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    Card,
    Tabs,
    Input,
    Button,
    Modal,
    Timeline,
    Icon,
    Divider,
    Tag,
    Table,
    Steps,
    Empty,
    message,
    Pagination, List, Row, Col, Spin, Switch
} from 'antd';
import DeliveryResources from "../components/deliveryResources/DeliveryResources";
import {ATTCHMENT_TYPE, AUDIO_TYPE, FILE_TYPE, PIC_TYPE, VIDEO_TYPE} from "../../constants";
import {Scrollbars} from "react-custom-scrollbars";
import {
    HEADER_HEIGHT,
    NAVIGATE_CLOSE,
    NAVIGATE_LEVEN2_MARGIN,
    NAVIGATE_LEVEN2_WIDTH,
    NAVIGATE_OPEN
} from "../../constants";
import cover from "../allResources/img/cover.png";
import video from "../allResources/img/video.png";
import audio from "../allResources/img/audio.png";
import file from "../allResources/img/file.png";
import ResourcePool from "../components/resourcePool/ResourcePool";
import HoldAll from "../../view/components/holdAll/HoldAll";
import *as Actions from "../../actions/deliveryResource"

import * as allResources from "../../actions/allResources";
import {
    getStoryById,
    newsclue,
    interview,
    douyin,
    getDeparment,
    getByAccount,
    weibo
} from '../../actions/deliveryResource'
import {getAllParent, getByPath, getPictureInfosByPath} from "../../actions/storageList";
import {formatDate, uuid} from "../../utils";
import audioCopy from './img/audioCopy.svg'
import otherCopy from './img/otherCopy.svg'
import videoCopy from './img/videoCopy.svg'
import piccopy from './img/piccopy.svg'

const {TabPane} = Tabs;
const {Search} = Input;
const {Step} = Steps;
const fileType = [{title: '稿件', fileType: 1,}
    , {title: '图片', fileType: 2,}
    , {title: '视频', fileType: 3,}
    , {title: '其他', fileType: 4,}
    , {title: '音频', fileType: 5,}
    , {title: '微信', fileType: 6,}
    , {title: '微博', fileType: 7,}];
export default class DeliveryResource extends Component {
    static defaultProps = {};
    static propTypes = {};


    constructor(props) {
        super(props);
        this.state = {
            tabsDate: [{title: '稿件', key: '1'}, {title: '线索', key: '3'}, {title: '任务', key: '4'},
                // {title: '微信', key: '7'},
                {title: '抖音', key: '8'}, {title: '微博', key: '7'}],//1-写稿 2-约稿 3-线索 4-采访 5-资源上传 6-微信 7-微博 8-抖音 9-通知公告
            resourcePath: false,
            dataSource: [ //入库资源库文件列表
            ],
            listArray: [],//列表数据源
            data: [],//默认入库数据
            resourcePool: false,
            manuscriptInformation: false,
            warehousing: false,
            current: 0,
            targetKeys: [],
            openAll: false,
            tableData: ["部门分享", "用户分享"],
            activeKey: '1',//顶部tab key
            searchText: '',
            inputConfigPaths: '',
            newListArray: [],//入库的数据源
            backList: [{name: '全部文件', _id: 0}],//入库资源菜单
            Information: {
                createDate: '',
                departName: '',
                submitter:''
            },
            start: 1,
            size: 10,
            title: '稿件',
            stepShare: true,
            showPublish: true,
            swithChecked: false,
            isSelectAll: false, // 是否全选
            taskTime:'提交时间',
            taskSubmitte:'提交人'
        }
    }

    componentWillMount() {
    }

    componentDidMount() {

        this.queryStoryUnSaveResource()
    }

    //获取稿件列表
    queryStoryUnSaveResource() {

        let params = {};
        if (this.state.searchText && this.state.searchText.trim().length > 0) {
            params.queryStr = this.state.searchText;

        }
        params.start = this.state.start;
        params.size = this.state.size;
        Actions.queryStoryUnSaveResource(params, res => {
            if (res) {
                this.formatDataSource(res)
            }
        })
    }

    //获取线索列表
    queryClueUnSaveResource() {
        let params = {};
        if (this.state.searchText && this.state.searchText.trim().length > 0) {
            params.queryStr = this.state.searchText;
        }
        params.start = this.state.start;
        params.size = this.state.size;
        Actions.queryClueUnSaveResource(params, res => {
            if (res) {
                this.formatDataSource(res)
            }
        })
    }

    //获取任务列表
    queryInterviewUnSaveResource() {
        let params = {};
        if (this.state.searchText && this.state.searchText.trim().length > 0) {
            params.queryStr = this.state.searchText;
        }
        params.start = this.state.start;
        params.size = this.state.size;
        Actions.queryInterviewUnSaveResource(params, res => {
            if (res) {
                this.formatDataSource(res)
            }
        })
    }

    //获取抖音列表
    queryDouyinUnSaveResource() {
        let params = {};
        if (this.state.searchText && this.state.searchText.trim().length > 0) {
            params.queryStr = this.state.searchText;
        }
        params.start = this.state.start;
        params.size = this.state.size;
        Actions.queryDouyinUnSaveResource(params, res => {
            if (res) {
                this.formatDataSource(res)
            }
        })
    }

    //获取微博列表
    queryWeiboUnSaveResource() {
        let params = {};
        if (this.state.searchText && this.state.searchText.trim().length > 0) {
            params.queryStr = this.state.searchText;
        }
        params.start = this.state.start;
        params.size = this.state.size;
        Actions.queryWeiboUnSaveResource(params, res => {
            if (res) {
                if (res) {
                    this.formatDataSource(res)
                }
            }
        })
    }

    tabOnChange = (key) => {
        this.state.start = 1;
        this.scrollRef && this.scrollRef.scrollToTop && this.scrollRef.scrollToTop();
        this.state.activeKey = key;
        this.state.searchText = '';
        this.setState({});
        this.typeChange();

    };

    typeChange() {
        switch (this.state.activeKey) {
            case '1':
                this.setState({title: '稿件',taskTime:'提交时间',taskSubmitte:'提交人'});
                this.queryStoryUnSaveResource();
                break;
            case '3':
                this.setState({title: '线索',taskTime:'提交时间',taskSubmitte:'提交人'});
                this.queryClueUnSaveResource();
                break;
            case '4':
                this.setState({title: '任务',taskTime:'任务创建时间',taskSubmitte:'任务创建人'});
                this.queryInterviewUnSaveResource();
                break;
            case '7':
                this.setState({title: '微博',taskTime:'提交时间',taskSubmitte:'提交人'});
                this.queryWeiboUnSaveResource();
                break;
            case '8':
                this.setState({title: '抖音',taskTime:'提交时间',taskSubmitte:'提交人'});
                this.queryDouyinUnSaveResource();

                break;
        }
    }

    //格式化数据。
    formatDataSource(res) {
        let data = [];
        let listArray = this.state.listArray;
        if (res && res.length > 0) {
            data = res;
            data.forEach(Item => {
                //添加一条数据用来实现全选功能
                Item['itemChecked'] = false;
                //格式化数据 图片数据
                let picResources = [];
                if (Item && Item.picResources) {
                    picResources = Item.picResources;
                    picResources.forEach((item, index) => {
                        item.type = "pic"
                    })
                }
                // 格式化视频数据
                let videoResources = [];
                if (Item && Item.videoResources) {
                    videoResources = Item.videoResources;
                    videoResources.forEach((item, index) => {
                        item.type = "video"
                    })
                }
                // 格式化音频
                let audioResources = [];
                if (Item && Item.audioResources) {
                    audioResources = Item.audioResources;
                    audioResources.forEach((item, index) => {
                        item.type = "audio"
                    })
                }
                //格式化其他文件
                let otherFileResources = [];
                if (Item && Item.otherFileResources) {
                    otherFileResources = Item.otherFileResources;
                    otherFileResources.forEach((item, index) => {
                        item.type = "other"
                    });
                }
                Item.list = [...picResources, ...videoResources, ...audioResources, ...otherFileResources]
            });
            if (this.state.start === 1) {
                listArray = data;
                this.setState({
                    listArray: listArray
                })
            } else {
                let array = listArray.concat(data);
                this.state.listArray = array
                this.setState({})
            }

        } else {
            if(this.state.start === 1){
                this.state.listArray = [];
                this.setState({});
            }

            return;
        }

    }

    render() {
        let height = window.innerHeight - HEADER_HEIGHT;//上部分70//
        let margin = 15;
        let otherHeight = 220 + margin * 2;
        return (
            <div>
                <Card title={'投递资源管理'} style={{margin: margin}}>
                    <style>{`.ant-card-head-title{font-size:14px}`}</style>
                    <div>
                        <Tabs activeKey={this.state.activeKey} onChange={this.tabOnChange}>
                            {
                                this.state.tabsDate.map((item, index) => {
                                    return (<TabPane tab={item.title} key={item.key}></TabPane>)
                                })
                            }
                        </Tabs>
                    </div>
                    <div style={{margin: '20px auto'}}>
                        <Search style={{width: '40%', marginLeft: '20%'}} value={this.state.searchText}
                                onChange={(e) => {
                                    this.setState({searchText: e.target.value})
                                }} onSearch={value => {
                            this.onSearch(value)
                        }}
                                enterButton/>
                        <Button type="primary" style={{marginLeft: '15%'}} onClick={this.selectAll}>{this.state.isSelectAll ? '全不选' : '全选'}</Button>
                        <Button type="primary" style={{marginLeft: 20}} onClick={this.warehousing}>入库</Button>
                        <Button type="primary" style={{marginLeft: 20}}
                                onClick={() => this.setUpStorage()}>设置默认入库方式</Button>
                    </div>

                    <div style={{height: height - otherHeight, background: 'white'}}>
                        {this.state.listArray && this.state.listArray.length > 0 ? <Scrollbars
                            onScroll={this.onScroll.bind(this)}
                            autoHide
                            autoHideTimeout={1}
                            autoHideDuration={1}
                            style={{height: height - otherHeight, position: 'relative'}}
                            ref={(scrollRef) => {
                                this.scrollRef = scrollRef
                            }}>


                            <div style={{marginLeft: 20, paddingTop: 20}}>

                                {
                                    this.state.listArray.map((Item, index) => {
                                        return (<Timeline.Item key={index} style={{width: '100%'}}>
                                            <div style={{cursor: 'pointer'}}
                                                 onClick={() => this.manuscriptInformation(Item)}>{Item.title || Item.content}</div>
                                            <div style={{display: 'flex', marginTop: 20}}>
                                                {
                                                    Item.list.length ? <div><Button onClick={() => {
                                                        this.oneSelectAll(Item)
                                                    }}>{Item.itemChecked ? '取消全选' : '全选'}</Button></div> : null
                                                }

                                                <div style={{width: '100%',}}>{
                                                    Item.list && Item.list.map((item, index) => {
                                                       
                                                        let path = item.path;
                                                        if (item.type === "video" ) {
                                                            path = item.path + '/thumbnails/1'
                                                        } else if(item.type === "audio"){
                                                            path =' /cm-sites/pms/library/images/audio.png'

                                                        } else if (item.type === "other") {

                                                            if (PIC_TYPE.indexOf(item.ext) > -1) {
                                                                path = path
                                                            }else if(VIDEO_TYPE.indexOf(item.ext) > -1){
                                                                path = item.path + '/thumbnails/1'
                                                            }else if(AUDIO_TYPE.indexOf(item.ext) > -1){
                                                                path =' /cm-sites/pms/library/images/audio.png'
                                                            }else {
                                                                path = "images/other.png"
                                                            }

                                                        }
                                                        return (
                                                            <DeliveryResources style={{background: 'red'}} img={path}
                                                                               type={item.type}
                                                                               key={index} checked={item.checked}
                                                                               ext={item.ext}
                                                                               imgOnclick={() => this.imgOnclick(item)}
                                                                               name={item.name}
                                                                               onChangeChecked={() => this.onChangeChecked(Item, item)}></DeliveryResources>)
                                                    })
                                                }
                                                </div>
                                            </div>
                                        </Timeline.Item>)
                                    })
                                }
                            </div>
                        </Scrollbars> : <Empty/>}

                    </div>


                </Card>

                {/*渲染资源配置*/}
                {this.renderResourceSetting()}
                {/*入库设置*/}
                {this.renderClassification()}
                {/*渲染稿件信息*/}
                {this.renderStoryInFor()}
                {/*渲染资源信息*/}
                {this.renderResourceInFor()}
            </div>
        )
    }

    /*监听滚动*/
    onScroll = e => {
        if (e.target.scrollTop + e.target.clientHeight === e.target.scrollHeight) {
            this.state.start = this.state.start + 1;
            this.typeChange()
        }
    };

    //渲染资源配置
    renderResourceSetting() {
        const columns = [
            {
                title: '文件类型',
                dataIndex: 'title',
                width: 200,
                render: (text, record) => {
                    let title = '';
                    fileType.forEach((item) => {
                        if (item.fileType == record.fileType) {
                            title = item.title;
                        }
                    });
                    return (
                        <div>{
                            title
                        }</div>
                    )
                },
            },
            {
                title: '资源存储路径',
                dataIndex: 'configPaths',
                render: (text, record) => (
                    <span>
                        {
                            record.open ? <a><Input style={{width: '80%'}} placeholder="请输入存储路径"
                                                    value={record.open ? this.state.inputConfigPaths : text}
                                                    onChange={(e) => {
                                                        this.state.inputConfigPaths = e.target.value;
                                                        this.setState({})
                                                    }}
                                                    onPressEnter={() => this.savePath(record.key)}/></a> :
                                <div style={{height: 32, lineHeight: '32px'}}>{text}</div>
                        }
                            </span>
                ),
            },
            {
                title: '操作',
                width: 300,
                render: (text, record) => (

                    <span>
                            <a><Button size='small' style={{marginRight: 10,}}
                                       onClick={() => this.editInputRecord(record)}>{record.open ? '取消' : '编辑'}</Button></a>
                        {record.open ? <a><Button size='small' style={{marginRight: 10,}}
                                                  onClick={() => {
                                                      record.configPaths = this.state.inputConfigPaths;
                                                      this.automaticStorage(record)
                                                  }}>保存</Button></a> : null}
                        <a><Button size='small' style={{marginRight: 10,}}
                                   onClick={() => {
                                       record.status = record.status === 0 ? 1 : 0;
                                       this.automaticStorage(record)
                                   }}>{record.status ? '关闭自动入库' : '开启自动入库'}</Button></a>
                            </span>
                ),
            },
        ];
        return (
            <Modal
                title="资源路径配置"
                visible={this.state.resourcePath}
                onOk={this.handleOk}
                width={1200}
                centered
                footer={null}
                onCancel={this.handleCancel}>
                <div style={{maxHeight: 750}}>
                    <Scrollbars autoHeight
                                autoHeightMax={750}>
                        <Table
                            columns={columns}
                            dataSource={this.state.data}
                            rowKey={(record) => record._id}
                            bordered
                            pagination={false}
                        />
                    </Scrollbars>
                </div>
            </Modal>
        )

    }

    //入库设置
    renderClassification() {
        return (
            <Modal
                title="设置入库"
                visible={this.state.warehousing}
                onOk={this.handleOk}
                width={'70%'}
                centered
                footer={null}
                onCancel={this.handleCancel}>
                <div>
                    <Steps current={this.state.current} labelPlacement={'vertical'}>
                        <Step description="资源入库"/>
                        <Step description="公开设置"/>
                        {
                            this.state.stepShare ? <Step description="分享设置"/> : null
                        }

                        {/* <Step description="下载设置"/>*/}
                        <Step description="设置完成"/>
                    </Steps>
                    <Scrollbars style={{height: '500px'}}>
                        {
                            this.state.current === 0 ? <div style={{padding: '0 40px'}}>
                                <div style={{marginTop: 40}}>
                                    <div>
                                        <span> 推荐目录:</span><span
                                        style={{display: 'inlineBlock', margin: '0 10px'}}><Switch size={'small'}
                                                                                                   checked={this.state.swithChecked}
                                                                                                   onChange={this.SwithChecked}/></span>
                                        <span style={{color: '#0050B3'}}>是否选择默认路径</span>
                                    </div>
                                    <div style={{display: 'flex', flexWrap: 'wrap', padding: '30px 10px'}}>
                                        {
                                            this.state.data.map((item, index) => {
                                                let title = '';
                                                fileType.forEach((Item) => {
                                                    if (Item.fileType == item.fileType) {
                                                        title = Item.title;
                                                    }
                                                });
                                                return (
                                                    <div style={{width: '50%', lineHeight: '60px'}} key={index}>
                                                        <img src={item.src} style={{
                                                            width: '30px',
                                                            objectFit: 'cover',
                                                            marginRight: 5
                                                        }}/>
                                                        <span title={item.configPaths} style={{

                                                            WebkitLineClamp: 2,
                                                            WebkitBoxOrient: 'vertical',
                                                            wordWrap: 'break-word',
                                                            overflow: 'hidden'
                                                        }}>{item.configPaths}</span>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                                {/*渲染返回上一级*/}
                                {this.renderBackNav()}
                                <div>
                                    <Scrollbars style={{height: '300px', marginTop: 10}}>
                                        {
                                            this.state.dataSource.map((item, index) => {
                                                return (< ResourcePool key={index} type={'small'}
                                                                       title={item.name} img={item.img}
                                                                       checked={item.checked}
                                                                       fileType={'file'}
                                                                       singleClick={() => {
                                                                           if (!this.state.swithChecked) {
                                                                               //入库设置资源入库文件单击
                                                                               this.inputResource(item)
                                                                           }
                                                                       }}
                                                                       doubleClick={() => {
                                                                           if (!this.state.swithChecked) {
                                                                               this.state.backList.push(item)
                                                                               this.inputResourceDoubleClick(item)
                                                                           }

                                                                       }}/>)
                                            })
                                        }
                                    </Scrollbars>
                                </div>

                                <div style={{clear: 'both'}}></div>
                            </div> : null
                        }
                        {
                            this.state.current === 1 || this.state.current === 2 /*|| this.state.current === 3*/ ?
                                <div style={{margin: '0 30px'}}>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        color: '#0050B3',
                                        marginTop: 40
                                    }}>
                                        <div style={{cursor: 'pointer'}} onClick={this.allChecked}>全选</div>
                                        {
                                            this.state.current === 1 ? <div><Button
                                                onClick={this.openAll}>{this.state.openAll ? '不公开' : '公开'}</Button>
                                            </div> : null
                                        }
                                        {
                                            this.state.current === 2 ?
                                                <div><Button onClick={this.download}>分享设置</Button></div> : null
                                        }
                                        {/* {
                                                this.state.current === 3 ?
                                                    <div><Button onClick={this.download}>下载设置</Button></div> : null
                                            }*/}
                                    </div>
                                    <div>
                                        {
                                            this.state.newListArray.map((Item, Index) => {
                                                //如果当前状态是1,公开不公开，的时候只展示列表选中
                                                return (
                                                    <div key={Index}>
                                                        <Divider
                                                            orientation="left">{Item.title || Item.content}</Divider>
                                                        <div style={{display: 'flex'}}>
                                                            <div style={{width: '92%'}}>{
                                                                Item.list.map((item, index) => {
                                                                    //如果当前状态是1,公开不公开，的时候只展示列表选中
                                                                    if (this.state.current === 1 && !item.checked) {
                                                                        return  //列表没被选中公开不展示
                                                                    }
                                                                    let checked;
                                                                    if (this.state.current === 1) {
                                                                        checked = item.publishChecked;
                                                                    }
                                                                    if (this.state.current === 2 && item.publish) {
                                                                        return  //列表被选中分享不展示，分享只设置未公开的
                                                                    }
                                                                    if (this.state.current === 2) {
                                                                        checked = item.shareChecked;
                                                                    }
                                                                    let path = item.path;
                                                                    if (item.type === "video" ) {
                                                                        path = item.path + '/thumbnails/1'
                                                                    } else if(item.type === "audio"){
                                                                        path =' /cm-sites/pms/library/images/audio.png'

                                                                    } else if (item.type === "other") {
                                                                        if (PIC_TYPE.indexOf(item.ext) > -1) {
                                                                            path = path
                                                                        }else if(VIDEO_TYPE.indexOf(item.ext) > -1){
                                                                            path = item.path + '/thumbnails/1'
                                                                        }else if(AUDIO_TYPE.indexOf(item.ext) > -1){
                                                                            path =' /cm-sites/pms/library/images/audio.png'
                                                                        }

                                                                    }
                                                                    return (
                                                                        <div key={Index + '' + index}>
                                                                            <DeliveryResources img={path}
                                                                                               type={item.type}
                                                                                               key={index}
                                                                                               checked={checked}
                                                                                               imgOnclick={() => {
                                                                                               }}

                                                                                               showPublishBtn={this.state.showPublish}
                                                                                               publish={item.publish}
                                                                                               singleOpen={() => {
                                                                                                   this.singleOpen(item)
                                                                                               }}
                                                                                               name={item.name}
                                                                                               onChangeChecked={() => this.onChangeModalItemChecked(item)}></DeliveryResources>
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                                <div style={{clear: 'both'}}/>
                                                                <HoldAll tableData={this.state.tableData}
                                                                         showProcess={false}
                                                                         onSaveCallback={(depr, user) => {
                                                                             this.onSaveCallback(depr, user)
                                                                         }}
                                                                         showTabs={true}
                                                                         ref={(HoldAll) => this.HoldAll = HoldAll}></HoldAll>

                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>

                                </div> : null
                        }
                        {
                            this.state.current === 3 ? <div style={{textAlign: 'center'}}>

                                <div><Icon type="check-circle"
                                           style={{fontSize: '80px', color: '#0050B3', marginTop: 145}}/></div>
                                <div style={{
                                    fontSize: '24px',
                                    color: '#666666',
                                    textAlign: 'center',
                                    lineHeight: '24px',
                                    marginTop: 40
                                }}>设置成功
                                </div>
                                <div style={{margin: '100px 0'}}><Button type="primary"
                                                                         onClick={this.complete}>完成</Button>
                                </div>
                            </div> : null
                        }


                    </Scrollbars>
                    {this.state.current === 0 ?
                        <div style={{textAlign: 'center', marginBottom: 40}}><Button type="primary"
                                                                                     onClick={this.oneNextStep}>下一步</Button>
                        </div> : null}
                    {this.state.current === 1 || this.state.current === 2 /*|| this.state.current === 3*/ ?
                        <div style={{textAlign: 'center', paddingBottom: 60}}><Button type="primary"
                                                                                      onClick={this.goBack}
                                                                                      style={{marginRight: 20}}>上一步</Button>
                            {/*<Button type="primary" onClick={this.noDistribution}>暂不分配</Button>*/}
                            <Button type="primary"
                                    style={{marginLeft: 20}}
                                    onClick={this.stepNext}>下一步</Button>


                        </div> : null}

                </div>

            </Modal>
        )
    }

    renderBackNav() {
        return (
            <div> {this.state.backList.length > 1 ?
                <span onClick={() => this.goBackNav()}>返回上一级&nbsp;</span> : null}<span>&nbsp;当前位置:</span>
                {
                    this.state.backList.map((item, index) => {

                        if (index === this.state.backList.length - 1) {
                            return (<span className={'ant-tabs-tab-active'} key={index}>{item.name}</span>)
                        } else {
                            return (<span key={index} onClick={() => {
                                    this.itemNavClick(item, index)
                                }}>{item.name}{'/'}</span>
                            )
                        }

                    })
                }
            </div>
        )
    }

    /*渲染稿件信息*/
    renderStoryInFor() {
        let showContentText = "";
        if (this.state.Information.content) {
            showContentText = this.state.Information.content.replace(/<[^>]*>/ig, "");
        }
        ;
        return (
            <Modal
                title={this.state.title + '信息'}
                visible={this.state.manuscriptInformation}
                width={'50%'}
                centered
                bodyStyle={{padding: '20px', background: '#f2f2f2'}}
                footer={null}
                onCancel={this.handleCancel}>

                <div style={{background: "white", padding: '20px'}}>
                    <div style={{
                        lineHeight: '30px',
                        fontWeight: 'bold',
                        color: ' rgb(108, 116, 139)'
                    }}>{this.state.title}名称:
                    </div>
                    <div style={{
                        lineHeight: '30px',
                        color: '#8792b3'
                    }}>{this.state.Information && this.state.Information.title}</div>
                    <div style={{display: 'flex', paddingRight: '0 40px', height: '70px', marginTop: 20}}>
                        <div style={{lineHeight: '30px', width: '33.3%'}}>
                            <div style={{fontWeight: 'bold', color: ' rgb(108, 116, 139)'}}>{this.state.taskSubmitte}:</div>
                            <div
                                style={{color: '#8792b3'}}>{this.state.Information && this.state.Information.submitter}</div>
                        </div>
                        <div style={{lineHeight: '30px', width: '33.3%'}}>
                            <div style={{fontWeight: 'bold', color: ' rgb(108, 116, 139)'}}>{this.state.taskTime}:</div>
                            <div
                                style={{color: '#8792b3'}}>{formatDate(this.state.Information && this.state.Information.createDate)}</div>
                        </div>
                        <div style={{lineHeight: '30px', width: '33.3%'}}>
                            <div style={{fontWeight: 'bold', color: ' rgb(108, 116, 139)'}}>所属部门:</div>
                            <div
                                style={{color: '#8792b3'}}>{this.state.Information && this.state.Information.departName}</div>
                        </div>
                    </div>
                    {this.state.activeKey==='1'?<div><div style={{marginTop: 20, fontWeight: 'bold', color: ' rgb(108, 116, 139)'}}>{this.state.title}摘要:</div>
                        <div style={{
                            marginTop: 10,
                            color: '#8792b3',
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            webkitBoxOrient: "vertical",
                            wordBreak: "break-all"
                        }}
                             dangerouslySetInnerHTML={{__html: this.state.Information.summary === "" ? showContentText : this.state.Information.summary}}></div></div>:''}

                </div>

            </Modal>
        )
    }

    /*渲染资源信息*/
    renderResourceInFor() {
        return (
            <Modal
                title="资源库"
                visible={this.state.resourcePool}
                onOk={this.handleOk}
                centered
                onCancel={this.handleCancel}
                width={'70%'}
                footer={null}
                bodyStyle={{backgroundColor: "white"}}
            >
                <div style={{display: 'flex', padding: '20px'}}>
                    <div style={{width: '70%', backgroundColor: "#f2f2f2", position: 'relative'}}>
                        <div style={{position: 'absolute', right: '50px', top: '50px'}}><Button
                            type="primary">入库</Button></div>
                        <div><img src='/storage/DFCBEA29DA0EBDA07E62AAD26C094170/small/quality' style={{
                            width: '508px',
                            height: '540px',
                            objectFit: 'cover',
                            paddingTop: 100,
                            display: 'block',
                            margin: '0 auto'
                        }}/></div>
                    </div>
                    <div style={{width: '30%', padding: '0 40px'}}>
                        <Tabs defaultActiveKey="1">
                            <TabPane tab="资源信息" key="1"></TabPane>
                            <TabPane tab="相关资源" key="2"></TabPane>
                        </Tabs>
                        <div style={{lineHeight: '60px'}}>基本信息</div>
                        <Divider style={{margin: 0}}/>
                        <div style={{lineHeight: '30px', display: 'flex', justifyContent: 'space-between'}}>
                            <div>图片名称:111111</div>
                            <div>途径:111111</div>
                        </div>
                        <div style={{lineHeight: '30px', display: 'flex', justifyContent: 'space-between'}}>
                            <div>所属部门:111111</div>
                            <div>上传人:111111</div>
                        </div>
                        <div style={{lineHeight: '30px'}}>时间:111111</div>
                        <div style={{lineHeight: '40px', display: 'flex', justifyContent: 'space-between'}}>
                            <div>像素:111111</div>
                            <div>大小:111111</div>
                        </div>
                        <Divider style={{margin: 0}}/>
                        <div style={{lineHeight: '60px'}}>相关部门</div>
                        <Divider style={{margin: 0}}/>
                        <div style={{lineHeight: '50px'}}>权限信息</div>
                        <Divider style={{margin: 0}}/>
                        <div style={{lineHeight: '50px'}}>部门资源</div>
                        <Divider style={{margin: 0}}/>
                        <div style={{height: '50px'}}>
                            <div>
                                <span>资源详情</span>
                                <span style={{marginLeft: 100}}><a>查看原稿</a></span>
                            </div>
                            <div>标签</div>

                        </div>
                        <Divider style={{margin: 0}}/>
                        <div style={{height: '200px', marginTop: 40}}>
                            <Scrollbars> <Tag color="#2db7f5" style={{marginBottom: 10}}>111</Tag>
                                <Tag color="#2db7f5" style={{marginBottom: 10}}>11119</Tag>
                                <Tag color="#2db7f5" style={{marginBottom: 10}}>1111115454</Tag>
                                <Tag color="#2db7f5"
                                     style={{marginBottom: 10}}>11111111111111111111</Tag></Scrollbars>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }

    SwithChecked = (checked) => {

        if (checked === true) {
            this.state.dataSource.forEach((item, index) => {
                item.checked = false
            });
            this.setState({})
        }
        this.setState({swithChecked: checked})
    };

    //搜索
    onSearch(value) {
        // this.state.searchText=value;
        this.state.start = 1;
        this.typeChange()
    }

    //公开按钮
    openAll = () => {
        let publishCheckedCount = 0;
        let numAll = 0;
        let publishNUm = 0;
        this.state.openAll = !this.state.openAll;
        this.state.newListArray.forEach((item, index) => {
            numAll = numAll + item.list.length;
            if (this.state.openAll) {
                item.publish = 1;
            } else {
                item.publish = 0;
            }
            item.list.forEach((e, index) => {
                if (e.publishChecked) {
                    publishCheckedCount++;
                    if (this.state.openAll === true) {
                        e.publish = 1;
                        publishNUm++;
                    }
                    if (this.state.openAll === false) {
                        e.publish = 0;
                    }
                }

            })
            if (numAll === publishNUm) {
                this.state.stepShare = false
            } else {
                this.state.stepShare = true
            }
        });
        if (publishCheckedCount === 0) {
            this.state.openAll = false;
            message.warn("请至少选择一个所需要公开/不公开的文件");
            return;
        }
        this.setState({});
    };

    //分享部门数据回调


    //分享用户回调


    onSaveCallback = (department, user) => {
        this.state.newListArray.forEach(Item => {
            Item.list.forEach(item => {
                if (item.shareChecked)
                    item.dsr = department;
                item.usr = user;
            })
            this.setState({})
        });
    };

    //单个的公开
    singleOpen(item) {
        if (this.state.current === 1) {
            if (item.publish) {
                item.publish = 0

            } else {
                item.publish = 1

            }
        }
        let parentNum = 0;
        let num = 0;
        this.state.newListArray.forEach(Item => {
            parentNum = parentNum + Item.list.length
            Item.list.forEach(item => {
                if (item.publish) {
                    Item.publish = 1;
                    num++
                }

            })
        });

        if (parentNum === num) {
            this.state.stepShare = false;
            this.state.openAll = true
        } else {
            this.state.openAll = false;
            this.state.stepShare = true
        }
        this.setState({})
    };

    //current 为0 的下一步
    oneNextStep = () => {
        let defaultInputArray = [];
        this.state.data.forEach((item, index) => {
            if (item.checked === true) {
                defaultInputArray.push(item)
            }
        });

        let array = [];
        this.state.dataSource.forEach((item, index) => {
            if (item.checked === true) {
                array.push(item)
            }
        });
        if (!this.state.swithChecked) {
            if (array.length || defaultInputArray.length) {
                this.setState({current: 1,})
            } else {
                message.info("请至少选择一个文件夹!");
            }
        } else {
            this.setState({current: 1,})
        }

    };
    //暂不分配
    noDistribution = () => {
        if (this.state.current === 1) {
            //如果当前位置是2，公开设置点击暂不分配的时候，把公开的数据的 公开全部改为不公开
            this.state.newListArray.forEach(Item => {
                Item.publish = 0;
                Item.list.forEach(item => {
                    item.publish = 0;
                })
            })
        }
        if (this.state.current === 2) {
            //如果当前位置是2，公开设置点击暂不分配的时候，把公开的数据的 公开全部改为不公开
            this.state.newListArray.forEach(Item => {
                Item.list.forEach(item => {
                    item.usr = [];
                    item.dsr = [];
                })
            })
        }
        this.publicNext()
    };

    publicNext() {
        let current = this.state.current;
        current = current + 1;
        /* if (currentAdd === 3) {
             this.setState({tableData: ["用户下载", "部门下载"]});
         }*/
        if (this.state.stepShare === true) {
            if (current === 2) {
                this.setState({tableData: ["部门分享", "用户分享",]});
                this.setState({publish: false, showPublish: false})
            }
            this.state.current = current;
            if (current === 3) {
                this.save()
            }
        } else {
            current = 3;
            this.save()
        }
        this.setState({current});

    };

    //返回上一层
    goBack = () => {

        let current = this.state.current;
        let currentAdd = current - 1;
        if (currentAdd === 0) {
            this.setState({stepShare: true})
        }
        if (currentAdd === 1) {
            this.setState({showPublish: true})
        }
        this.setState({current: currentAdd,});
    };
    //下一步
    stepNext = () => {
        this.publicNext()
    };
    //点击下载按钮
    download = () => {
        let num = 0;
        this.state.newListArray.forEach((item, index) => {
            if (item.shareChecked === true) {
                num++
            }
        });
        if (num > 0) {
            this.HoldAll.show();
        } else {
            message.warn("请至少选择一个所需要分享/不分享的文件");
        }

    };
    //点击完成按钮
    complete = () => {
        this.state.start = 1;

        this.typeChange();
        this.setState({warehousing: false});
    };
    //入库
    warehousing = () => {
        this.state.backList = [{name: '全部文件', _id: 0}];
        let num = 0;
        let newListArray = [];
        let newArray = this.state.listArray
        newArray.forEach((item, index) => {

            if (item.checked) {
                let list = [];

                if (item.list.length) {
                    item.list.forEach(childItem => {
                        if (childItem.checked) {
                            childItem.publish = 0;//初始化入库状态
                            list.push(childItem)
                        }
                    });
                    item.list = list;
                    newListArray.push(item)

                }
            }
        });
        if (newListArray.length === 0) {
            return message.info('请选中资源!')
        }
        let params = {fileSource: this.state.activeKey};
        this.getRootDir();
        Actions.getFileUploadPathConfigList(params, res => {
            let data = [];
            if (res && res.data) {
                res.data.forEach((item, index) => {
                    if (item.fileType === 2) {
                        item.src = piccopy
                    } else if (item.fileType === 3) {
                        item.src = videoCopy
                    } else if (item.fileType === 5) {
                        item.src = audioCopy
                    } else if (item.fileType === 4) {
                        item.src = otherCopy
                    }
                })
                data = res.data;
            }
            this.setState({
                warehousing: true,
                current: 0,
                data,
                newListArray,
                stepShare: true,
                showPublish: true,
                swithChecked: false,
                openAll: false
            });
        });

    };

    //获取入库默认根目录
    getRootDir() {
        Actions.getRootDir(res => {
            let dataSource = [];
            if (res && res.length > 0) {
                dataSource = res;
            }
            this.setState({dataSource})
        })
    }

    manuscriptInformation(item) {
        this.setState({manuscriptInformation: true,});
        if (this.state.activeKey === '1') {
            getStoryById(item.id, (data) => {
                this.state.Information = data;
                this.state.Information.createDate = data.submitDate.time;
                data.deptIds = [data.initialDeptId];
                this.getName(data)
                this.setState({})

            })

        } else if (this.state.activeKey === '3') {
            newsclue(item.id, (data) => {
                this.state.Information = data;
                this.state.Information.createDate = data.submitDate.time;

                this.getName(data)
                this.setState({})
            })
        } else if (this.state.activeKey === '4') {
            interview(item.id, (data) => {
                this.state.Information = data;
                this.state.Information.createDate = data.createDate.time;
                this.state.Information.submitter = data.createrName;
                this.getName(data)
                this.setState({})
            })
        } else if (this.state.activeKey === '8') {
            douyin(item.id, (data) => {
                this.getName(data)
                this.setState({Information: data})
            })
        } else if (this.state.activeKey === '7') {
            weibo(item.id, (data) => {
                data.title = data.content;
                this.getName(data)
                this.setState({Information: data})
            })
        }

    };
    getName(data){
       let  submitter;
       if(this.state.activeKey === '4'){
           submitter = data.creater
       }else{
           submitter= data.submitter
       }
        getByAccount(submitter, (res) => {
            this.state.Information.submitter = res.name
            getDeparment(res.deptIds, (response) => {
                this.state.Information.departName = response.name;
                this.setState({})
            });
        });
    }

    //点击enter键输入框的变化
    savePath(key) {
        this.state.data.forEach((item, index) => {
            if (key === item.key) {
                item.open = false
            }
        });
        this.setState({})
    }


    //点击开启关闭按钮
    automaticStorage(record) {
        let params = record;
        Actions.updateStatus(params, res => {
            let params = {fileSource: this.state.activeKey};
            Actions.getFileUploadPathConfigList(params, res => {
                let data = [];
                if (res && res.data) {
                    data = res.data;
                }
                this.setState({resourcePath: true, data});
            });
        })
    }

    //点击编辑
    editInputRecord(record) {
        this.state.inputConfigPaths = record.configPaths;
        this.state.imgSrc = record.src;
        record.open = !record.open;
        this.setState({})
    };

    //每一项点击详情预览
    imgOnclick(item) {
        this.itemReview(item)
        //this.setState({resourcePool: true,});
    };

    //取消按钮的事件
    handleCancel = e => {
        this.typeChange();
        this.setState({
            resourcePool: false,
            resourcePath: false,
            manuscriptInformation: false,
            warehousing: false,
            isSelectAll: false,
        });
    };

    //设置默认入库方式
    setUpStorage() {
        let params = {fileSource: this.state.activeKey};
        Actions.getFileUploadPathConfigList(params, res => {
            let data = [];
            if (res && res.data) {
                data = res.data;
            }
            this.setState({resourcePath: true, data});
        });
    };


    //所有的全选
    selectAll = () => {
        this.state.listArray.forEach((item, index) => {
            item.list.forEach((e, index) => {
                e.checked = !this.state.isSelectAll;
            });
            item.checked = !this.state.isSelectAll;
            item.itemChecked = !this.state.isSelectAll;
        });
        this.state.isSelectAll = !this.state.isSelectAll;
        this.setState({})
    };


    //入库全选
    allChecked = () => {
        this.state.newListArray.forEach((item, index) => {
            if (this.state.current === 1) {
                item.publised = true;

            }
            if (this.state.current === 2) {
                item.shareChecked = true;
            }
            item.list.forEach((e, index) => {
                if (this.state.current === 1) {
                    e.publishChecked = true;
                }
                if (this.state.current === 2 && e.publish === 0) {
                    e.shareChecked = true;
                }
            })
        });
        this.setState({})
    };

    //单个的全选
    oneSelectAll(record) {
        record.list.forEach((item, index) => {
            item.checked = !record.itemChecked;
        });
        record.checked = !record.itemChecked;
        record.itemChecked = !record.itemChecked;
        this.setState({})
    };

    //列表切换checked
    onChangeChecked(Item, item) {
        item.checked = !item.checked;
        let num = 0;
        Item.list.forEach((current, index) => {
            if (current.checked) {
                Item.checked = true;
                num++;
            }
        });
        if (num === 0) {
            Item.checked = false;
        }
        Item.itemChecked = Item.list.every(e => e.checked === true);
        this.setState({})
    }

    //入库弹出框列表选中
    onChangeModalItemChecked(item) {

        //公开点击
        if (this.state.current === 1) {
            item.publishChecked = !item.publishChecked;

            this.state.newListArray.forEach(Item => {

                Item.list.forEach(itm => {
                    console.log(itm, 'itm')
                    if (item.publishChecked) {
                        Item.publishChecked = true;
                        if (itm.publish === 1) {
                            this.setState({stepShare: false})
                        } else {
                            this.setState({stepShare: true})
                        }
                    }

                });
            })
        }
        //分享
        if (this.state.current === 2) {
            item.shareChecked = !item.shareChecked;
            this.state.newListArray.forEach(Item => {
                Item.list.forEach(itm => {
                    if (item.shareChecked) {
                        Item.shareChecked = true;
                    }
                });
            })
        }
        this.setState({});

    }

    //入库设置 默认资源设置
    defaultInputResource(item) {
        item.checked = !item.checked;
        this.setState({})
    }

    //入库设置，资源入库文件夹单选
    inputResource(record) {
        this.state.dataSource.forEach(item => {
            item.checked = false;
        });
        record.checked = !record.checked;
        this.setState({})

    }

    //入库双击进入下一层文件
    inputResourceDoubleClick(record) {
        allResources.getresourcesList(record._id, (data) => {
            let dataSource = [];
            if (data.directorys && data.directorys.length > 0) {
                dataSource = data.directorys;
            }
            this.setState({dataSource})
        })
    }

    //返回上一级
    goBackNav() {
        let record = this.state.backList[this.state.backList.length - 2];
        this.state.backList.splice(this.state.backList.length - 1, 1);
        if (record._id) {

            this.inputResourceDoubleClick(record)
        } else {

            this.getRootDir()
        }

    }

    //nav每一项点击
    itemNavClick(item, index) {
        let current = index;
        let deleteNUm = this.state.backList.length - index;
        this.state.backList.splice(index + 1, deleteNUm - 1);
        if (item._id) {
            this.inputResourceDoubleClick(item)
        } else {
            this.state.backList = [{name: '全部文件', _id: 0}];
            this.getRootDir()
        }
    }


    //保存
    save() {
        let params = {
            newDirId: '',
            pictures: [],
            videos: [],
            audios: [],
            otherFiles: [],
        };
        this.state.dataSource.forEach(item => {
            if (item.checked) {
                params.newDirId = item._id;
            }
        });

        this.state.newListArray.forEach(Item => {
            Item.list.forEach(item => {
                if (item.type === "pic") {
                    params.pictures.push(item)
                }
                if (item.type === "video") {
                    params.videos.push(item)
                }
                if (item.type === "audio") {
                    params.audios.push(item)
                }
                if (item.type === "other") {
                    params.otherFiles.push(item)
                }
            })
        });
        Actions.manualSaveAll(params, res => {
            this.setState({});
        });
    }

    itemReview(item) {
        let path = item.path;
        let fileType = item.type;
        let id = item._id;
        const MARGIN = 15;
        let baseWidth = window.$(window).width() - (this.props.navigateStatus ? NAVIGATE_OPEN : NAVIGATE_CLOSE) - NAVIGATE_LEVEN2_MARGIN - NAVIGATE_LEVEN2_WIDTH;
        let baseHeight = window.$(window).height() - HEADER_HEIGHT;
        let offsetX = parseInt(this.props.navigateStatus ? NAVIGATE_OPEN : NAVIGATE_CLOSE) + parseInt(NAVIGATE_LEVEN2_MARGIN) + parseInt(NAVIGATE_LEVEN2_WIDTH) + MARGIN;
        let offsetY = parseInt(HEADER_HEIGHT) + MARGIN;
        if (fileType === 'pic') {
            let picFiles = [item];
            let that = this;
            window.layui.config({
                base: '/cm-sites/layuiadmin/' //静态资源所在路径
            }).extend({
                index: 'lib/index' //主入口模块
            }).use(["index", "buttons"], function () {
                let buttons = window.layui.buttons;
                getByPath(path, (pic) => {
                    //图片滚动预览
                    let pictureList = picFiles;
                    let index = 0;

                    let picPaths = [];
                    //获取当前图片在数组中的索引；
                    for (let i = 0; i < pictureList.length; i++) {
                        picPaths.push(pictureList[i].path);
                    }

                    //更具paths获取pictureinfos
                    let params = {paths: picPaths};
                    getPictureInfosByPath(params, function (pics) {
                        for (let i = 0; i < pics.length; i++) {
                            if (pics[i].path == pic.path) {
                                index = i;
                                break;
                            }
                        }
                        let viewPic = {
                            list: pics,
                            index: index
                        };
                        buttons.view(viewPic, 2, "图片详情", that.props.baseWidth, that.props.baseHeight, that.props.offsetX, that.props.offsetY);
                    })
                });
            })
        } else if (fileType === 'video') {
            let that = this;
            window.layui.config({
                base: '/cm-sites/layuiadmin/' //静态资源所在路径
            }).extend({
                index: 'lib/index' //主入口模块
            }).use(["index", "buttons"], function () {
                let buttons = window.layui.buttons;
                getByPath(path, (video) => {
                    if (video) {
                        buttons.view(video, 3, "视频详情", baseWidth, baseHeight, offsetX, offsetY);
                    } else {
                        message.error("该资源不在媒资库中，无法查看。");
                    }
                });
            })
        } else if (fileType === 'audio') {
            let that = this;
            window.layui.config({
                base: '/cm-sites/layuiadmin/' //静态资源所在路径
            }).extend({
                index: 'lib/index' //主入口模块
            }).use(["index", "buttons"], function () {
                let buttons = window.layui.buttons;
                getByPath(path, (audio) => {
                    if (audio) {
                        buttons.view(audio, 5, "音频详情", baseWidth, baseHeight, offsetX, offsetY);
                    } else {
                        message.error("该资源不在媒资库中，无法查看。");
                    }
                });
            })
        } else if (fileType === "other") {
            let that = this;
            window.layui.config({
                base: '/cm-sites/layuiadmin/' //静态资源所在路径
            }).extend({
                index: 'lib/index' //主入口模块
            }).use(["index", "buttons"], function () {
                let buttons = window.layui.buttons;
                window.loading.show();
                getByPath(path, (file) => {
                    window.loading.hide();
                    if (file) {
                       if (PIC_TYPE.indexOf(item.ext) > -1){
                            buttons.view(file, 2, "图片详情", that.props.baseWidth, that.props.baseHeight, that.props.offsetX, that.props.offsetY);
                        }else if(VIDEO_TYPE.indexOf(item.ext) > -1){
                            buttons.view(file, 3, "视频详情", that.props.baseWidth, that.props.baseHeight, that.props.offsetX, that.props.offsetY);
                        }else if(AUDIO_TYPE.indexOf(item.ext) > -1){
                            buttons.view(file, 5, "音频详情", that.props.baseWidth, that.props.baseHeight, that.props.offsetX, that.props.offsetY);
                        }else{
                        buttons.view(file, 4, "文件详情", that.props.baseWidth, that.props.baseHeight, that.props.offsetX, that.props.offsetY);
                         }
                    } else {
                        message.error("该资源不在媒资库中，无法查看。");
                    }
                });
            })
        }


    };
}
